import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import MainTabsNav from '../components/MainTabsNav';
import PremiumProviders, { type PremiumProviderItem } from '../components/PremiumProviders';

/**
 * 우수 인증 교육기관 독립 라우트(/premium-providers) — 광고 랜딩용.
 * Layout(Header/Footer) 안에서 메인 탭바 + 우수 인증 소개 랜딩을 보여준다.
 */
export default function PremiumProvidersPage() {
  const [providers, setProviders] = useState<PremiumProviderItem[]>([]);

  useEffect(() => {
    const fetchPremiumProviders = async () => {
      try {
        const res = await fetch('/api/v1/providers/premium');
        if (res.ok) {
          const data = await res.json();
          setProviders(data.providers || []);
        }
      } catch (err) {
        console.error('Failed to fetch premium providers:', err);
      }
    };
    fetchPremiumProviders();
  }, []);

  return (
    <div className="bg-gray-50">
      <Helmet>
        <title>우수 인증 교육기관 | STAMP FIT</title>
        <meta
          name="description"
          content="교육 업력·강사진·커리큘럼·운영 역량을 종합 평가한 STAMP FIT 우수 인증 교육 기관을 만나보세요."
        />
      </Helmet>

      <MainTabsNav />

      <div className="px-6 sm:px-10 lg:px-16">
        <PremiumProviders providers={providers} />
      </div>
    </div>
  );
}
